<template>
  <section>
    <section>Skill Extension ⚔️</section>
    <section>
      <img src="@/assets/images/taro-logo.png" alt="" width="200" />
    </section>

    <section>
      <p>
        <img
          src="@/assets/images/nuxtjs-logo.svg"
          alt=""
          height="50"
          style="margin-right:20px"
        />
        <img src="@/assets/images/nuxtjs-title.svg" alt="" height="40" />
      </p>

      <p class="fragment fade-up">
        <b class="mark">S</b>erver <b class="mark">S</b>ide
        <b class="mark">R</b>ender
      </p>
    </section>
  </section>
</template>
